import { createContext, useContext } from 'react';

/**
 * A DOM node in the instrument card's title row that an instrument body can
 * render its own controls into.
 *
 * Without this, each instrument type rendered its controls as a band *below*
 * the title: a table card read as title / M-Q-Y / grid (three stacked bands),
 * while a variance card read as title / grid. Two instruments sitting side by
 * side on the same dashboard therefore started their grids at different
 * heights, and the table's controls band left a stripe of dead space no other
 * card had.
 *
 * Instruments portal into this slot instead, so every card is one row of
 * `title … controls` followed immediately by its content, whatever type it is.
 *
 * `null` is the valid "no slot here" value — the instrument editor modal
 * renders these same bodies outside a card, and they fall back to rendering
 * their controls inline.
 */
const InstrumentHeaderSlotContext = createContext<HTMLElement | null>(null);

export const InstrumentHeaderSlotProvider = InstrumentHeaderSlotContext.Provider;

export const useInstrumentHeaderSlot = () => useContext(InstrumentHeaderSlotContext);

export default InstrumentHeaderSlotContext;
